<img [src]="photoURL" alt="" [style.width]="size" [style.height]="size" class="rounded-circle" />
